"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeHeatFilterScoreBatchDTO = exports.decodeHeatFilterScoreBatchModelFromDTO = void 0;
const E = __importStar(require("fp-ts/Either"));
const function_1 = require("fp-ts/function");
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const codecs_1 = require("../codecs");
const errors_1 = require("../errors");
const HeatFilterScoreBatchModel = t.exact(t.type({
    correlation_id: io_ts_types_1.UUID,
    heat_filter_id: io_ts_types_1.UUID,
    queued_at: io_ts_types_1.DateFromISOString,
    batch: t.number,
    total_batches: t.number,
    orgnr: t.array(codecs_1.OrgnrCodec),
}));
const decodeHeatFilterScoreBatchModelFromDTO = (input) => (0, function_1.pipe)(input, HeatFilterScoreBatchModel.decode, E.mapLeft((0, errors_1.toValidationError)('Could not decode input in decodeHeatFilterScoreBatchDTO', input)));
exports.decodeHeatFilterScoreBatchModelFromDTO = decodeHeatFilterScoreBatchModelFromDTO;
exports.encodeHeatFilterScoreBatchDTO = HeatFilterScoreBatchModel.encode;
// export const decodeHeatFilterScoreBatchDTO = pipe(HeatFilterScoreBatchModel, decodeFn(''));
// export const end
//# sourceMappingURL=model.js.map